import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function RTMIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x={3} y={3} width={18} height={18} rx={3} />
        <polyline points="7 16.5 9.8 13.6 12.2 15.4 14.2 13.4" />
        <path
          transform="translate(15.4 8.2) scale(0.8) translate(-15.4 -8.2)"
          d="M15.4 11.2s-3-1.8-3-4a1.6 1.6 0 0 1 3-.8 1.6 1.6 0 0 1 3 .8c0 2.2-3 4-3 4Z"
        />
      </g>
    </SvgIcon>
  );
}
